import { render, staticRenderFns } from "./AccountResources.vue?vue&type=template&id=d2e59e8c&"
import script from "./AccountResources.vue?vue&type=script&lang=ts&"
export * from "./AccountResources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports